import {
  List,
  Datagrid,
  TextField,
  TextInput,
  SelectInput,
  UrlField,
  ReferenceInput,
  Filter,
} from "react-admin";

import CustomActions from "../../../components/CustomActions";
import { ListPagination } from "../../../utils";
import { exporter } from "../utils";

const SampleFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Nome" source="name" alwaysOn />
    <TextInput label="Descrição" source="description" />
    <TextInput label="URL" source="url" />
    <ReferenceInput
      sort={{ field: "name", order: "ASC" }}
      perPage={999}
      resource="lab"
      label="Laboratório"
      source="labId"
      reference="labs"
    >
      <SelectInput label="Laboratório" optionText="name" optionValue="id" />
    </ReferenceInput>
    <TextInput label="Código da Amostra" source="sample_id" />
    <TextInput label="Código EAN" source="ean" />
  </Filter>
);

const SampleList = (props) => (
  <List
  hasCreate={true}
  bulkActionButtons={<div />}
  perPage={25}
  title="Lista de Amostras"
  exporter={exporter}
  filters={<SampleFilter />}
  actions={<CustomActions />}
  sort={{ field: "createdAt", order: "DESC" }}
  pagination={<ListPagination />}
  {...props}
  >
    <Datagrid rowClick="edit">
      <TextField label="Nome" source="name" />
      <TextField label="Descrição" source="description" />
      <UrlField label="URL" source="url" />
      <TextField sortable={false} label="Laboratório" source="lab.name" />
      <TextField label="Código da Amostra" source="sample_id" /> 
      <TextField sortable={false} label="Código EAN" source="ean" emptyText="Não coletado" />
    </Datagrid>
  </List>
);

export default SampleList;
